(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4270);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ CButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67841);
/* harmony import */ var _mantine_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8798);






var CButton = function(param) {
    var title = param.title, route = param.route, props = param.props, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        title: title,
        className: className,
        component: _mantine_next__WEBPACK_IMPORTED_MODULE_5__/* .NextLink */ .p,
        href: route
    }, props), {
        children: title
    }));
};


/***/ }),

/***/ 49847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ CIconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64761);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49834);





var CIconButton = function(param) {
    var className = param.className, onClick = param.onClick, label = param.label, dark = param.dark, light = param.light, props = param.props;
    var colorScheme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .useMantineTheme */ .rZ)().colorScheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .ActionIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        onClick: onClick
    }, props), {
        children: [
            colorScheme === "dark" ? dark : light,
            label && label
        ]
    }));
};


/***/ }),

/***/ 10773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useIsMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsMounted(true);
    }, []);
    return isMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsMounted);


/***/ }),

/***/ 42085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchPropertiesInputAtom */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15103);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48583);
/* harmony import */ var _core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47048);
/* harmony import */ var _utils_date_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54938);




//STATE
var searchRangeValueAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)([
    null,
    null
]);
var selectedKeywordAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)("");
var selectedGuestCountAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)(0);
var searchPropertiesInputAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    keyword: null,
    guestCount: 0,
    startDate: null,
    endDate: null
});
var useSearchData = function() {
    var isReadyToSearch = function isReadyToSearch() {
        if (!(0,_core_utils__WEBPACK_IMPORTED_MODULE_2__/* .empty */ .cS)(getSelectedKeyword()) || (0,_core_utils__WEBPACK_IMPORTED_MODULE_2__/* .isRangeValid */ .x5)(getSearchRangeValue()) || getSelectedGuestCount() !== 0) {
            setSearchBarInput({
                keyword: getSelectedKeyword(),
                guestCount: getSelectedGuestCount(),
                startDate: (0,_utils_date_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatSearchDate */ .vF)(getSearchRangeValue()[0]),
                endDate: (0,_utils_date_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatSearchDate */ .vF)(getSearchRangeValue()[1])
            });
            /*console.log(
                extractTags(
                    getSelectedKeyword(),
                    getSelectedGuestCount(),
                    formatSearchDate(getSearchRangeValue()[0]),
                    formatSearchDate(getSearchRangeValue()[1])
                ), '')*/ return true;
        } else {
            return false;
        }
    };
    // STATE RANGE
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(searchRangeValueAtom), 2), _searchRangeValue = ref[0], _setSearchRangeValue = ref[1];
    var getSearchRangeValue = function() {
        return _searchRangeValue;
    };
    var setSearchRangeValue = function(range) {
        _setSearchRangeValue(range);
    };
    // STATE KEYWORD
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(selectedKeywordAtom), 2), _selectedKeyword = ref1[0], _setSelectedKeyword = ref1[1];
    var getSelectedKeyword = function() {
        return _selectedKeyword;
    };
    var setSelectedKeyword = function(keyword) {
        _setSelectedKeyword(keyword);
    };
    // STATE GUEST COUNT
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(selectedGuestCountAtom), 2), _selectedGuestCount = ref2[0], _setSelectedGuestCount = ref2[1];
    var getSelectedGuestCount = function() {
        return _selectedGuestCount;
    };
    var setSelectedGuestCount = function(count) {
        _setSelectedGuestCount(count);
    };
    // SEARCH BAR COMPLETE STATE
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(searchPropertiesInputAtom), 2), _searchBarInput = ref3[0], _setSearchBarInput = ref3[1];
    var getSearchBarInput = function() {
        return _searchBarInput;
    };
    var setSearchBarInput = function(input) {
        _setSearchBarInput(input);
    };
    return {
        getSearchRangeValue: getSearchRangeValue,
        setSearchRangeValue: setSearchRangeValue,
        getSelectedKeyword: getSelectedKeyword,
        setSelectedKeyword: setSelectedKeyword,
        getSelectedGuestCount: getSelectedGuestCount,
        setSelectedGuestCount: setSelectedGuestCount,
        getSearchBarInput: getSearchBarInput,
        setSearchBarInput: setSearchBarInput,
        isReadyToSearch: isReadyToSearch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchData);


/***/ }),

/***/ 23377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ClientOnly; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var ClientOnly = function(_param) {
    var children = _param.children, delegated = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasMounted = ref[0], setHasMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, delegated), {
        children: children
    }));
};


/***/ }),

/***/ 4270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/core/components/common/AppHead.tsx
var AppHead = __webpack_require__(46055);
// EXTERNAL MODULE: ./src/core/layouts/AppLayout.tsx + 27 modules
var AppLayout = __webpack_require__(74797);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./src/core/router/AppRoutes.ts
var AppRoutes = __webpack_require__(84396);
// EXTERNAL MODULE: ./src/core/components/common/CButton.tsx
var CButton = __webpack_require__(77829);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Overlay/Overlay.js + 1 modules
var Overlay = __webpack_require__(17577);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
// EXTERNAL MODULE: ./src/lib/ClientOnly.tsx
var ClientOnly = __webpack_require__(23377);
// EXTERNAL MODULE: ./src/core/components/common/CIconButton.tsx
var CIconButton = __webpack_require__(49847);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Autocomplete/Autocomplete.js + 2 modules
var Autocomplete = __webpack_require__(52785);
// EXTERNAL MODULE: ./src/core/utils/dxb-utils.ts
var dxb_utils = __webpack_require__(10646);
// EXTERNAL MODULE: ./src/core/hooks/use-is-mounted.ts
var use_is_mounted = __webpack_require__(10773);
// EXTERNAL MODULE: ./src/features/search/hooks/use-search-data.ts
var use_search_data = __webpack_require__(42085);
// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
;// CONCATENATED MODULE: ./src/features/search/components/SearchByLocation.tsx











var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var _obj;
    return {
        autocompleteInput: (_obj = {
            position: "relative",
            width: 190
        }, (0,_define_property/* default */.Z)(_obj, theme.fn.smallerThan("sm"), {
            width: "100%"
        }), (0,_define_property/* default */.Z)(_obj, "input", {
            height: "auto",
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14
        }), (0,_define_property/* default */.Z)(_obj, "& .mantine-Autocomplete-icon", {
            top: 38,
            fontSize: 20
        }), (0,_define_property/* default */.Z)(_obj, "label", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1
        }), (0,_define_property/* default */.Z)(_obj, "& .mantine-Autocomplete-description", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        }), (0,_define_property/* default */.Z)(_obj, "& .mantine-Autocomplete-input::placeholder", {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        }), (0,_define_property/* default */.Z)(_obj, "& .mantine-Autocomplete-error", {
            fontSize: 12,
            paddingTop: 6
        }), _obj)
    };
});
var SearchByLocation = function() {
    var classes = useStyles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    // LOCAL
    var ref = (0,react.useState)(null), localValue = ref[0], setLocalValue = ref[1];
    var setSelectedKeyword = (0,use_search_data/* default */.Z)().setSelectedKeyword;
    // SSR
    var data = (0,graphql/* useGetSearchLocationsQuery */.d1)().data;
    var ref1 = (0,react.useState)([]), searchLocations = ref1[0], setSearchLocations = ref1[1];
    var ref2 = (0,react.useState)([]), keywords = ref2[0], setKeywords = ref2[1];
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.getSearchLocations) {
            setSearchLocations(data === null || data === void 0 ? void 0 : data.getSearchLocations);
            setKeywords((0,dxb_utils/* extractKeywords */.Zv)(searchLocations));
        }
    }, [
        data,
        searchLocations
    ]);
    (0,react.useEffect)(function() {
        if (!localValue) {
            setSelectedKeyword(localValue);
        }
    }, [
        localValue
    ]);
    var autoCompData = keywords.map(function(item) {
        return {
            keyword: item,
            value: item
        };
    });
    var AutoCompleteItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
        var keyword = _param.keyword, value = _param.value, others = (0,_object_without_properties/* default */.Z)(_param, [
            "keyword",
            "value"
        ]);
        return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, others), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                noWrap: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: value
                })
            })
        }));
    });
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* Autocomplete */.F, {
        className: classes.autocompleteInput,
        radius: "xs",
        onItemSubmit: function(item) {
            return setSelectedKeyword(item === null || item === void 0 ? void 0 : item.value);
        },
        nothingFound: "No Locations found",
        // limit={3}
        initiallyOpened: false,
        label: "Your destination",
        description: "Where would you like to go?",
        placeholder: "example: Dubai Marina",
        itemComponent: AutoCompleteItem,
        // value={localValue}
        onChange: setLocalValue,
        data: autoCompData,
        filter: function(value, item) {
            return item.value.toLowerCase().includes(value.toLowerCase().trim());
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/dates/esm/components/RangeCalendar/RangeCalendar.js + 32 modules
var RangeCalendar = __webpack_require__(28807);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(97564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Popover/Popover.js + 9 modules
var Popover = __webpack_require__(40405);
// EXTERNAL MODULE: ./src/core/utils/date-utils.ts
var date_utils = __webpack_require__(54938);
// EXTERNAL MODULE: ./src/core/hooks/use-dxb-theme.ts
var use_dxb_theme = __webpack_require__(33451);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
;// CONCATENATED MODULE: ./src/features/search/components/RangeSearch/SearchByRange.styles.ts


/* harmony default export */ var SearchByRange_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        rangeCal: {
            //This is the .mantine-RangeCalendar-calendarBase
            maxWidth: "fit-content",
            width: "fit-content",
            gap: 20,
            padding: 20,
            border: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            borderRadius: theme.radius.xs,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            // boxShadow: theme.shadows.sm,
            ".mantine-RangeCalendar-calendarHeader": {
                height: 60,
                borderBottom: 1,
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                borderColor: theme.colors.orange[5],
                borderStyle: "dashed",
                paddingTop: 5,
                paddingBottom: 5,
                color: theme.colors.dark[3]
            },
            ".mantine-RangeCalendar-calendarHeaderLevel": {
                color: theme.colors.dark[2],
                borderRadius: theme.radius.md,
                // position: 'absolute',
                fontSize: 16,
                fontWeight: 400,
                letterSpacing: 1
            },
            ".mantine-RangeCalendar-calendarHeaderControl": {
                borderRadius: theme.radius.md,
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
                "&:hover": {
                    backgroundColor: theme.colorScheme === "dark" ? theme.colors.gray[7] : theme.colors.gray[4]
                }
            },
            ".mantine-RangeCalendar-weekday": (0,_define_property/* default */.Z)({
                borderBottom: 1,
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                borderColor: theme.colors.orange[5],
                borderStyle: "dashed",
                paddingBottom: 10,
                fontSize: 12,
                letterSpacing: 1,
                textTransform: "uppercase"
            }, theme.fn.smallerThan("md"), {
                fontSize: 12
            }),
            /*'.mantine-RangeCalendar-weekdayCell': {
            paddingBottom: 10,
        },*/ ".mantine-RangeCalendar-cell": {
                textAlign: "center"
            },
            ".mantine-RangeCalendar-day": (_obj = {
                margin: 2,
                borderRadius: theme.radius.md,
                // width: '100%',
                fontSize: 12
            }, // width: 34,
            // height: 34,
            (0,_define_property/* default */.Z)(_obj, theme.fn.smallerThan("md"), {
                fontSize: 12,
                margin: 4
            }), /*[theme.fn.smallerThan('sm')]: {
                fontSize: 12,
                margin: 4,
            },*/ (0,_define_property/* default */.Z)(_obj, "&[data-selected]", {
                backgroundColor: theme.colors.orange[4],
                borderRadius: theme.radius.md,
                position: "relative"
            }), (0,_define_property/* default */.Z)(_obj, "&[data-in-range]", {
                backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.orange[7], 0.2) : theme.colors.orange[0],
                borderRadius: theme.radius.md
            }), (0,_define_property/* default */.Z)(_obj, "&[data-first-in-range]", {
                backgroundColor: theme.colors.orange[4],
                borderRadius: theme.radius.md,
                position: "relative",
                "&::after": {
                    content: '""',
                    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.orange[7], 0.2) : theme.colors.orange[0],
                    position: "absolute",
                    right: 0,
                    left: 20,
                    top: 0,
                    bottom: 0,
                    zIndex: -1
                }
            }), (0,_define_property/* default */.Z)(_obj, "&[data-last-in-range]", {
                backgroundColor: theme.colors.orange[4],
                borderRadius: theme.radius.md,
                "&::after": {
                    content: '""',
                    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.orange[7], 0.2) : theme.colors.orange[0],
                    position: "absolute",
                    left: 0,
                    right: 20,
                    top: 0,
                    bottom: 0,
                    zIndex: -1
                }
            }), (0,_define_property/* default */.Z)(_obj, "&[data-weekend]", {
                // color: theme.colors.orange[5],
                color: theme.colors.orange[9]
            }), (0,_define_property/* default */.Z)(_obj, "&[disabled]", {
                color: theme.colors.gray[5],
                textDecoration: "line-through",
                textDecorationColor: theme.colors.orange[5]
            }), _obj),
            ".mantine-RangeCalendar-monthPickerControl": {
                margin: 2,
                flex: "0 0 20%"
            },
            ".mantine-RangeCalendar-monthPickerControlActive": {
                backgroundColor: theme.colors.orange[3],
                "&:hover": {
                    backgroundColor: theme.colors.orange[5]
                }
            }
        },
        checkPopover: {
            padding: 0
        },
        popupDropdown: (0,_define_property/* default */.Z)({
            border: "none",
            padding: 0,
            background: "none"
        }, theme.fn.smallerThan("sm"), {
            top: "370px !important"
        }),
        stackMain: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            width: "100%"
        }),
        checkWrapper: {
            marginTop: 2,
            gap: 0
        },
        checkInMain: (_obj1 = {
            position: "relative",
            height: "auto",
            paddingRight: theme.spacing.sm,
            borderRadius: theme.radius.xs
        }, (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("sm"), {
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            borderRight: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }), (0,_define_property/* default */.Z)(_obj1, theme.fn.smallerThan("sm"), {
            width: "100%",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            borderBottom: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }), _obj1),
        checkOutMain: (_obj2 = {
            position: "relative",
            height: "auto",
            paddingRight: theme.spacing.sm,
            borderRadius: theme.radius.xs
        }, (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("sm"), {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }), (0,_define_property/* default */.Z)(_obj2, theme.fn.smallerThan("sm"), {
            width: "100%",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }), _obj2),
        checkLabel: {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 10,
            fontWeight: 500,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            zIndex: 1
        },
        checkDescription: {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            lineHeight: 1.2,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
            zIndex: 1
        },
        checkInput: {
            height: "auto",
            minWidth: 150,
            lineHeight: "34px",
            paddingLeft: theme.spacing.sm,
            paddingRight: theme.spacing.sm,
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/search/components/RangeSearch/SearchByRangeLabels.tsx







var SearchByRangeLabels = function(param) {
    var _onClose = param._onClose;
    var classes = SearchByRange_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var getSearchRangeValue = (0,use_search_data/* default */.Z)().getSearchRangeValue;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
        popupType: "dialog",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            className: classes.checkWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                    className: classes.checkInMain,
                    onClick: function() {
                        _onClose();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.checkLabel,
                                children: "Check in"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.checkDescription,
                                children: "When will your arrive?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.checkInput,
                                children: (0,date_utils/* formatSearchBarDateLabel */.EX)(getSearchRangeValue()[0], "Select date")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                    className: classes.checkOutMain,
                    onClick: function() {
                        _onClose();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.checkLabel,
                                children: "Check out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.checkDescription,
                                children: "When do you plan to leave?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.checkInput,
                                children: (0,date_utils/* formatSearchBarDateLabel */.EX)(getSearchRangeValue()[1], "Select date")
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/RangeSearch/SearchByRange.tsx










var SearchByRange = function() {
    var classes = SearchByRange_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref = (0,use_search_data/* default */.Z)(), setSearchRangeValue = ref.setSearchRangeValue, getSearchRangeValue = ref.getSearchRangeValue;
    var isSmallScreen = (0,use_dxb_theme/* default */.Z)().isSmallScreen;
    var ref1 = (0,react.useState)(false), isRangeVisible = ref1[0], setIsRangeVisible = ref1[1];
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        className: classes.stackMain,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
            position: "bottom",
            opened: isRangeVisible,
            onChange: setIsRangeVisible,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchByRangeLabels, {
                    _onClose: function() {
                        setIsRangeVisible(!isRangeVisible);
                        //RESET
                        setSearchRangeValue([
                            null,
                            null
                        ]);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                    className: classes.popupDropdown,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeCalendar/* RangeCalendar */.V, {
                        // ref={ref}
                        value: getSearchRangeValue(),
                        onChange: function(range) {
                            setSearchRangeValue(range);
                            if (range[1] !== null) {
                                setIsRangeVisible(false);
                            }
                        },
                        // sx={classes}
                        className: classes.rangeCal,
                        firstDayOfWeek: "monday",
                        weekendDays: [
                            0
                        ],
                        allowLevelChange: false,
                        amountOfMonths: isSmallScreen ? 2 : 1,
                        excludeDate: function(date) {
                            return (0,date_utils/* disablePastDates */.rJ)(date);
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(10753);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
;// CONCATENATED MODULE: ./src/features/search/components/GuestCount/SearchByGuestCount.styles.ts


/* harmony default export */ var SearchByGuestCount_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        stackMain: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            width: "100%"
        }),
        guestWrapper: {
            marginTop: 2,
            gap: 0
        },
        guestMain: (0,_define_property/* default */.Z)({
            position: "relative",
            height: "auto",
            paddingRight: theme.spacing.sm,
            borderRadius: theme.radius.xs,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }, theme.fn.smallerThan("sm"), {
            width: "100%"
        }),
        guestLabel: {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 10,
            fontWeight: 500,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            zIndex: 1
        },
        guestDescription: {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            lineHeight: 1.2,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
            zIndex: 1
        },
        guestInput: {
            height: "auto",
            minWidth: 120,
            lineHeight: "34px",
            paddingLeft: theme.spacing.sm,
            paddingRight: theme.spacing.sm,
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        },
        guestGroup: (0,_define_property/* default */.Z)({
            width: 130,
            gap: 27
        }, theme.fn.smallerThan("sm"), {
            ".mantine-Group-child": {
                width: 20,
                flexDirection: "row"
            }
        }),
        guestText: {
            width: 20
        },
        guestIcon: {
            color: theme.colors.orange[7]
        },
        clearButton: {
            fontWeight: 500,
            letterSpacing: 1,
            textTransform: "uppercase"
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/search/components/GuestCount/SearchByGuestCount.tsx











var SearchByGuestCount = function() {
    var onPlus = function onPlus() {
        if (count >= guestsLimit) return;
        setCount(function(c) {
            return c + 1;
        });
    };
    var onMinus = function onMinus() {
        var currentCount = count - 1;
        if (currentCount >= 0) {
            setCount(currentCount);
        } else {
            setCount(0);
        }
    };
    var classes = SearchByGuestCount_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var setSelectedGuestCount = (0,use_search_data/* default */.Z)().setSelectedGuestCount;
    // COUNT LIMIT
    var data = (0,graphql/* useGetMaxGuestCountQuery */.xz)().data;
    var ref = (0,react.useState)(0), guestsLimit = ref[0], setGuestsLimit = ref[1];
    var ref1 = (0,react.useState)(0), count = ref1[0], setCount = ref1[1];
    var ref2 = (0,react.useState)(false), isSelectorVisible = ref2[0], setIsSelectorVisible = ref2[1];
    var ref3 = (0,use_click_outside/* useClickOutside */.O)(function() {
        setIsSelectorVisible(false);
        setSelectedGuestCount(count);
    });
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.getMaxGuestCount) {
            setGuestsLimit(data === null || data === void 0 ? void 0 : data.getMaxGuestCount.max);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        setSelectedGuestCount(count);
    }, [
        count
    ]);
    var Counter = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        ref: ref3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                className: classes.guestGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CIconButton/* CIconButton */.E, {
                        onClick: function() {
                            return onMinus();
                        },
                        light: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMinus */.UrD, {
                            className: classes.guestIcon,
                            size: 20,
                            stroke: 1
                        }),
                        dark: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMinus */.UrD, {
                            className: classes.guestIcon,
                            size: 20,
                            stroke: 1
                        }),
                        props: {
                            variant: "outline",
                            radius: "xs"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.guestText,
                        size: 14,
                        align: "center",
                        children: count
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CIconButton/* CIconButton */.E, {
                        onClick: function() {
                            return onPlus();
                        },
                        light: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconPlus */.SC9, {
                            className: classes.guestIcon,
                            size: 20,
                            stroke: 1
                        }),
                        dark: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconPlus */.SC9, {
                            className: classes.guestIcon,
                            size: 20,
                            stroke: 1
                        }),
                        props: {
                            variant: "outline",
                            radius: "xs"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: classes.clearButton,
                radius: "xs",
                disabled: count === 0,
                fullWidth: true,
                onClick: function() {
                    return setCount(0);
                },
                children: "Clear"
            })
        ]
    });
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        className: classes.stackMain,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
            opened: isSelectorVisible,
            onChange: setIsSelectorVisible,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                    popupType: "dialog",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        className: classes.guestWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                            className: classes.guestMain,
                            onClick: function() {
                                setIsSelectorVisible(!isSelectorVisible);
                            // setCount(0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        className: classes.guestLabel,
                                        children: "Guests"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        className: classes.guestDescription,
                                        children: "Traveling with others?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        className: classes.guestInput,
                                        children: (0,dxb_utils/* formatGuestsCount */.NQ)(count, "Add Guests")
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                    children: isSelectorVisible && Counter
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/bar/SearchBar.styles.ts


/* harmony default export */ var SearchBar_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        searchLocationClient: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            width: "100%"
        }),
        searchGroup: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            width: "100%",
            paddingBottom: 16,
            paddingRight: 16,
            paddingLeft: 16,
            ".mantine-Group-child": {
                width: "100%"
            }
        }),
        searchGlass: (0,_define_property/* default */.Z)({
            width: 70,
            borderRadius: theme.radius.xs,
            fontWeight: 400,
            fontSize: theme.fontSizes.sm,
            flexDirection: "column",
            height: "auto",
            gap: 10,
            marginTop: 2,
            paddingTop: theme.spacing.sm,
            paddingBottom: theme.spacing.sm,
            paddingLeft: theme.spacing.xs,
            paddingRight: theme.spacing.xs,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }, theme.fn.smallerThan("sm"), {
            width: "100%"
        })
    };
}));

// EXTERNAL MODULE: ./src/core/hooks/useNotification.ts
var useNotification = __webpack_require__(96682);
;// CONCATENATED MODULE: ./src/features/search/components/bar/SearchBar.tsx

















var SearchBar = function() {
    var notify = (0,useNotification/* default */.Z)().notify;
    var classes = SearchBar_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,use_search_data/* default */.Z)(), isReadyToSearch = ref.isReadyToSearch, setSearchBarInput = ref.setSearchBarInput;
    (0,react.useEffect)(function() {
        setSearchBarInput({
            keyword: null,
            guestCount: 0,
            startDate: null,
            endDate: null
        });
    }, []);
    var onSubmitSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isReadyToSearch()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            router.push(AppRoutes/* AppRoutes.SEARCH */.$w.SEARCH)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        notify(useNotification/* NotificationType.INFO */.k.INFO, "Please select your dates to search.", 4000);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmitSearch() {
            return _ref.apply(this, arguments);
        };
    }();
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        className: classes.searchGroup,
        spacing: 10,
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientOnly/* ClientOnly */.q, {
                className: classes.searchLocationClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchByLocation, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchByRange, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientOnly/* ClientOnly */.q, {
                className: classes.searchLocationClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchByGuestCount, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CIconButton/* CIconButton */.E, {
                className: classes.searchGlass,
                label: "Search",
                onClick: onSubmitSearch,
                light: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconSearch */.jVj, {
                    color: "orange",
                    size: 32,
                    stroke: 1
                }),
                dark: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconSearch */.jVj, {
                    color: "orange",
                    size: 32,
                    stroke: 1
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/home/components/Hero/HeroBanner.styles.ts


var CONTAINER_HEIGHT = 500;
var SM_CONTAINER_HEIGHT = 600;
/* harmony default export */ var HeroBanner_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        hero: {
            position: "relative",
            backgroundImage: "url(https://dxbstay-site-media.s3.amazonaws.com/dxbstay-banner.webp)",
            // backgroundImage: 'url(https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80)',
            backgroundSize: "cover",
            backgroundPosition: "center",
            // maxWidth: 1200,
            margin: "0 auto",
            marginBottom: theme.spacing.xl
        },
        container: (0,_define_property/* default */.Z)({
            height: CONTAINER_HEIGHT,
            maxWidth: theme.other.maxWidth,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            marginBottom: theme.spacing.xl * 3.5,
            zIndex: 10,
            position: "relative"
        }, theme.fn.smallerThan("sm"), {
            height: SM_CONTAINER_HEIGHT,
            marginBottom: 0
        }),
        paper: (0,_define_property/* default */.Z)({
            margin: "0 auto",
            textAlign: "justify",
            fontSize: 13,
            maxWidth: theme.other.maxWidth,
            padding: 10,
            boxShadow: theme.shadows.sm,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7],
            marginBottom: theme.spacing.xl * -2
        }, theme.fn.smallerThan("sm"), {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            width: "100%",
            marginBottom: theme.spacing.xl
        }),
        title: (0,_define_property/* default */.Z)({
            color: theme.white,
            fontSize: 20,
            fontWeight: 200,
            lineHeight: 2,
            textAlign: "center",
            paddingBottom: CONTAINER_HEIGHT / 12,
            textShadow: theme.shadows.sm
        }, theme.fn.smallerThan("sm"), {
            display: "none"
        }),
        titleXS: (0,_define_property/* default */.Z)({
            fontSize: 16,
            paddingBottom: 10,
            paddingTop: 10,
            margin: "0 auto",
            borderRadius: theme.radius.xs,
            textAlign: "center",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            width: "100%",
            color: theme.colorScheme === "dark" ? theme.white : theme.colors.dark[3],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }, theme.fn.largerThan("sm"), {
            display: "none"
        })
    };
}));

;// CONCATENATED MODULE: ./src/features/home/components/Hero/HeroBanner.tsx





var HeroBanner = function() {
    var classes = HeroBanner_styles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.hero,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
                gradient: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .35) 80%)",
                opacity: 1,
                zIndex: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        className: classes.title,
                        children: "Top Locations | Spectacular Views | Unforgettable Experience"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                        className: classes.titleXS,
                        children: [
                            "Top Locations | Spectacular Views",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Unforgettable Experience"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {})
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/carousel/esm/Carousel.js + 10 modules
var Carousel = __webpack_require__(69263);
;// CONCATENATED MODULE: ./src/features/home/components/Carousal/Slide/CarouselSlide.styles.ts

/* harmony default export */ var CarouselSlide_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        card: {
            height: 350,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            backgroundSize: "cover",
            backgroundPosition: "center",
            boxShadow: "none",
            border: "none"
        },
        carouselText: {
            width: "100%",
            padding: theme.spacing.xl,
            borderRadius: theme.radius.xs,
            background: theme.fn.gradient({
                from: theme.fn.rgba(theme.black, 0.6),
                to: theme.fn.rgba(theme.white, 0),
                deg: 180
            })
        },
        title: {
            color: theme.white,
            lineHeight: 1.2,
            fontSize: 32,
            marginTop: theme.spacing.xs
        },
        category: {
            color: theme.white,
            opacity: 0.7,
            fontSize: 12,
            textTransform: "uppercase"
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/home/components/Carousal/Slide/CarouselSlide.tsx





var CarouselSlide = function(param) {
    var title = param.title, category = param.category, backgroundImage = param.backgroundImage;
    var classes = CarouselSlide_styles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel.Slide */.l.Slide, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
            // shadow="md"
            // p="xl"
            radius: "xs",
            sx: {
                backgroundImage: "url(".concat(backgroundImage, ")")
            },
            className: classes.card,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.carouselText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.category,
                        size: "xs",
                        children: category
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 1,
                        className: classes.title,
                        children: title
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/core/utils/network-utils.ts
var network_utils = __webpack_require__(41448);
;// CONCATENATED MODULE: ./src/features/home/components/Carousal/HomeCarousel.tsx





var HomeCarousel = function(param) {
    var slidesData = param.slidesData;
    // TODO: GET THE PLACE HOLDER IMAGE - SPECIFIC TO THIS
    var emptySlide = /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselSlide, {
        backgroundImage: "https://images.unsplash.com/photo-1508193638397-1c4234db14d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
        title: "NO TITLE",
        category: "NO HEADING"
    });
    var dataSlides = slidesData.map(function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselSlide, {
            backgroundImage: "".concat(network_utils/* S3_SITE_MEDIA_BUCKET_URL */.g5, "/").concat(data.background_image_url),
            title: data.title,
            category: data.heading
        }, data.title);
    });
    var slides = dataSlides.length !== 0 ? dataSlides : emptySlide;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        mb: "xl",
        mx: "auto",
        slideSize: "70%",
        slideGap: "sm",
        breakpoints: [
            {
                maxWidth: "xl",
                slideSize: "33.30%"
            },
            {
                maxWidth: "md",
                slideSize: "50%"
            },
            {
                maxWidth: "sm",
                slideSize: "100%",
                slideGap: 0
            }, 
        ],
        slidesToScroll: 1,
        loop: true,
        controlsOffset: "xl",
        align: "start",
        sx: function(theme) {
            return {
                maxWidth: theme.other.maxWidth,
                ".mantine-Carousel-controls": {
                    top: "calc(85% - 13px)"
                },
                ".mantine-Carousel-indicators": {
                    bottom: 34
                }
            };
        },
        draggable: true,
        withIndicators: true,
        withControls: true,
        styles: {
            control: {
                "&[data-inactive]": {
                    opacity: 0,
                    cursor: "default"
                }
            }
        },
        previousControlLabel: "Previous Benefit",
        nextControlLabel: "Next Benefit",
        children: slides
    });
};

// EXTERNAL MODULE: ./src/features/common/cards/PropertyItem/PropertyItemCard.tsx + 3 modules
var PropertyItemCard = __webpack_require__(66127);
// EXTERNAL MODULE: ./src/features/common/hooks/use-user-data.ts
var use_user_data = __webpack_require__(85992);
;// CONCATENATED MODULE: ./src/features/home/components/Scroller/FeaturedScroller.tsx







var FeaturedScroller = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(data), localData = ref[0], setLocalData = ref[1];
    var ref1 = (0,use_user_data/* default */.Z)(), getUserId = ref1.getUserId, getUserPropIds = ref1.getUserPropIds;
    (0,react.useEffect)(function() {
        if (getUserPropIds()) {
            var updatedData = (0,dxb_utils/* mapFavParamToProps */.QL)(getUserPropIds(), data);
            setLocalData(updatedData);
        }
    }, [
        getUserPropIds()
    ]);
    var slides = localData === null || localData === void 0 ? void 0 : localData.map(function(slide) {
        var ref, ref1;
        var thumbUrl = (ref1 = slide === null || slide === void 0 ? void 0 : (ref = slide.images) === null || ref === void 0 ? void 0 : ref.filter(function(img) {
            return img.type === "thumb" && img;
        })[0]) === null || ref1 === void 0 ? void 0 : ref1.src;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel.Slide */.l.Slide, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyItemCard/* PropertyItemCard */.o, {
                propertyId: slide.id,
                name: slide.name,
                thumb: thumbUrl && "".concat(network_utils/* S3_PROPERTY_BUCKET_URL */.oe, "/").concat(thumbUrl),
                address: (0,dxb_utils/* getAddressText */.ol)(slide.location),
                amount: slide.priceDetails.pricePerNight,
                currency: "AED",
                details: slide.details,
                //Don't Show featured tag as it is already in featured list
                isFeatured: false,
                settings: slide.settings,
                isFavVisible: getUserId() !== -1,
                // @ts-expect-error
                isFav: slide.isFavProp
            })
        }, slide.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        mb: "xl",
        mx: "auto",
        slideSize: "70%",
        slideGap: "sm",
        breakpoints: [
            {
                maxWidth: "xl",
                slideSize: "33.30%"
            },
            {
                maxWidth: "md",
                slideSize: "50%"
            },
            {
                maxWidth: "sm",
                slideSize: "100%",
                slideGap: 0
            }, 
        ],
        slidesToScroll: 1,
        loop: true,
        controlsOffset: "sm",
        align: "start",
        sx: function(theme) {
            return {
                maxWidth: theme.other.maxWidth,
                ".mantine-Carousel-controls": {
                    top: "calc(35% - 13px)"
                }
            };
        },
        draggable: true,
        withIndicators: false,
        withControls: true,
        styles: {
            control: {
                "&[data-inactive]": {
                    opacity: 0,
                    cursor: "default"
                }
            }
        },
        previousControlLabel: "Previous Property",
        nextControlLabel: "Next Property",
        children: slides
    });
};

;// CONCATENATED MODULE: ./src/features/home/containers/HomeLanding.styles.ts


/* harmony default export */ var HomeLanding_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        homeLanding: {
            margin: "0 auto",
            maxWidth: "100%"
        },
        homeInner: {
            margin: "0 auto",
            maxWidth: theme.other.maxWidth
        },
        viewButton: (0,_define_property/* default */.Z)({
            fontWeight: 400,
            borderStyle: "dashed",
            borderWidth: 1,
            borderColor: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[6],
            ":hover": {
                borderColor: theme.colors.orange[5]
            }
        }, theme.fn.smallerThan("sm"), {
            minWidth: "50%",
            margin: "auto",
            marginBottom: 20,
            marginTop: -20
        }),
        h1: (0,_define_property/* default */.Z)({
            flex: 1,
            letterSpacing: 0.6
        }, theme.fn.smallerThan("sm"), {
            minWidth: "100%",
            fontSize: 16,
            textAlign: "center"
        })
    };
}));

// EXTERNAL MODULE: ./src/core/hooks/use-app-data.ts
var use_app_data = __webpack_require__(81819);
;// CONCATENATED MODULE: ./src/features/home/containers/HomeLanding.tsx










var HomeLanding = function(param) {
    var featuredScrollerData = param.featuredScrollerData, siteCarousalData = param.siteCarousalData;
    var classes = HomeLanding_styles().classes;
    var setLastPage = (0,use_app_data/* default */.Z)().setLastPage;
    (0,react.useEffect)(function() {
        setLastPage(AppRoutes/* AppRoutes.HOME */.$w.HOME);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                className: classes.homeLanding,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: classes.homeInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                        className: classes.h1,
                                        mb: 20,
                                        order: 1,
                                        children: "Discover what DXB Stay has to offer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CButton/* CButton */.u, {
                                        className: classes.viewButton,
                                        title: "View all offers",
                                        route: AppRoutes/* AppRoutes.PROPERTIES */.$w.PROPERTIES,
                                        props: {
                                            variant: "default",
                                            mb: 20
                                        }
                                    })
                                ]
                            }),
                            featuredScrollerData.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedScroller, {
                                data: featuredScrollerData
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                align: "center",
                                color: "dimmed",
                                pb: 20,
                                children: "We are working on enhancing your experience."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: classes.homeInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                className: classes.h1,
                                mb: 20,
                                order: 1,
                                children: "Benefits of booking with us"
                            }),
                            siteCarousalData.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCarousel, {
                                slidesData: siteCarousalData
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                align: "center",
                                color: "dimmed",
                                pb: 20,
                                children: "We are working on enhancing your experience."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx





var HomePage = function(param) {
    var siteCarousalData = param.siteCarousalData, featuredScrollerData = param.featuredScrollerData, time = param.time;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLanding, {
            siteCarousalData: siteCarousalData,
            featuredScrollerData: featuredScrollerData
        })
    });
};
// @ts-expect-error
HomePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHead/* default */.Z, {
                title: "Luxury Vacation Rentals",
                description: "DXB Stay offers luxury vacation rental apartments in Dubai. Our rental properties offer exclusive views of landmarks and are located in key locations around Dubai."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
                requireAuth: false,
                children: page
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,662,930,151,810,521,263,207,127,774,888,377], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);